import { defineMessages } from 'react-intl';

export default defineMessages({
  prorated: {
    id: 'pages.metric.prorated',
    defaultMessage: 'Prorated',
  },
  pipeline: {
    id: 'pages.metric.pipeline',
    defaultMessage: 'Pipeline',
  },
  excellence: {
    id: 'pages.metric.excellence',
    defaultMessage: 'Excellence',
  },
  revenueNo: {
    id: 'pages.metric.revenueNo',
    defaultMessage: 'Revenue New & Organic',
  },
  revenueEx: {
    id: 'pages.metric.revenueEx',
    defaultMessage: 'Revenue Existing',
  },
  dm: {
    id: 'pages.metric.dm',
    defaultMessage: 'Direct Margin',
  },
  billability: {
    id: 'pages.metric.billability',
    defaultMessage: 'Billability',
  },
  inverseProportion: {
    id: 'pages.metric.inverseProportion',
    defaultMessage: 'Inverse Proportion',
  },
  proratedInfo: {
    id: 'pages.metric.proratedInfo',
    defaultMessage: 'Prorated (actual ÷ target)',
  },
  pipelineInfo: {
    id: 'pages.metric.pipelineInfo',
    defaultMessage:
      'Anything below 60% of target = 0{br}' +
      '60% – 199.99% = prorated (actual ÷ target, up to 2.0){br}' +
      '200%+ = capped at 2.0{br}',
  },
  excellenceInfo: {
    id: 'pages.metric.excellenceInfo',
    defaultMessage: 'Anything below 95% of target = 0{br}95%+ = 1{br}',
  },
  revenueNoInfo: {
    id: 'pages.metric.revenueNoInfo',
    defaultMessage:
      'Anything below 61% of target = 0{br}' +
      '61% – 79.99% = 0.5{br}' +
      '80% – 109.99% = prorated (actual ÷ target, up to 1.1){br}' +
      '111% - 149.99% = (actual ÷ target) + 0.1{br}' +
      '150% – 199.99% = prorated (actual ÷ target, up to 2.0){br}' +
      '200%+ = capped at 2.0{br}',
  },
  revenueExInfo: {
    id: 'pages.metric.revenueExInfo',
    defaultMessage:
      'Anything below 90% of target = 0{br}' +
      '90% – 109.99% = prorated (actual ÷ target, up to 1.1){br}' +
      '111% - 149.99% = (actual ÷ target) + 0.1{br}' +
      '150% – 199.99% = prorated (actual ÷ target, up to 2.0){br}' +
      '200%+ = capped at 2.0{br}',
  },
  dmInfo: {
    id: 'pages.metric.dmInfo',
    defaultMessage:
      'DM below 40.5% = 0{br}' +
      'DM 40.5% = 0.07{br}' +
      'DM 42% = 0.13{br}' +
      'DM 43% = 0.2{br}' +
      'DM 44% = 0.27{br}' +
      'DM 45% = 0.33{br}' +
      'DM 46% = 0.4{br}' +
      'DM 47% = 0.47{br}' +
      'DM 48% = 0.53{br}' +
      'DM 49% = 0.6{br}' +
      'DM 50% = 0.67{br}' +
      'DM 51% = 0.73{br}' +
      'DM 52% = 0.8{br}' +
      'DM 53% = 0.87{br}' +
      'DM 54% = 0.93{br}' +
      'DM 55% = 1{br}' +
      'DM 56% - 58.9999999% = 1.1{br}' +
      'DM 59 - 61.9999999% = 1.2{br}' +
      'DM 62 - 64.9999999% = 1.3{br}' +
      'DM 65 - 67.99999999% = 1.4{br}' +
      'DM 68 - 70.9999999 = 1.5{br}' +
      'DM 71 - 72.99999 = 1.6{br}' +
      'DM 73 - 75.999999 = 1.7{br}' +
      'DM 76 - 78.9999999 = 1.8{br}' +
      'DM 79 - 81.999999 = 1.9{br}' +
      '82 and up = 2.0{br}',
  },
  billabilityInfo: {
    id: 'pages.metric.billabilityInfo',
    defaultMessage:
      'Target for everyone: 9-30h{br}' +
      '0-5h = 0{br}' +
      '6-8h = 0.5{br}' +
      '9-15h = 0.75{br}' +
      '16-18h = 1{br}' +
      'above 18h = 1.5{br}',
  },
  inverseProportionInfo: {
    id: 'pages.metric.inverseProportionInfo',
    defaultMessage: 'Inverse Proportion (target ÷ actual)',
  },
  currency: {
    id: 'pages.metric.currency',
    defaultMessage: 'Currency',
  },
  percentage: {
    id: 'pages.metric.percentage',
    defaultMessage: 'Percentage',
  },
  number: {
    id: 'pages.metric.number',
    defaultMessage: 'Number',
  },
});
